import { Component, inject, model } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { SelectUsersListComponent } from '@app/shared/components/select-users-list/select-users-list.component';
import { User } from '@app/shared/types/models/user/user.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';

export interface SelectUsersDialogData {
  titleKey: string;
  users: User[];
  preselectedUserIds?: string[];
  lockedUserIds?: string[];
  emptyMessageKey?: string;
  returnIdsOnly?: boolean;
}

/** Input for {@link DialogService.openSelectCompanyUsersDialog}. */
export interface SelectCompanyUsersDialogData {
  users: User[];
  preselectedUserIds: string[];
}

/**
 * Generic multi-user select modal — replaces duplicated users pickers across features.
 */
@Component({
  selector: 'proffeo-select-users-dialog',
  templateUrl: './select-users-dialog.component.html',
  imports: [TranslatePipe, UiDialogComponent, SelectUsersListComponent, UiButtonComponent, MatDialogClose]
})
export class SelectUsersDialogComponent {
  private readonly dialogRef =
    inject<MatDialogRef<SelectUsersDialogComponent, string[] | User[] | undefined>>(MatDialogRef);

  protected readonly data = inject<SelectUsersDialogData>(MAT_DIALOG_DATA);
  protected readonly selectedUserIds = model<string[]>(this.data.preselectedUserIds ?? []);

  protected save(): void {
    if (this.data.returnIdsOnly) {
      this.dialogRef.close(this.selectedUserIds());
      return;
    }

    const selectedUsers = this.data.users.filter(user => this.selectedUserIds().includes(user.id));
    this.dialogRef.close(selectedUsers);
  }
}
